import bigInt from 'big-integer'; // You'll need to install this package
import { jwtDecode } from 'jwt-decode';
import { format } from "date-fns";
import { fr } from "date-fns/locale";
const joursEnFrancais = {
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  sunday: "Dimanche",
};
// Email validation function
export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
    return emailRegex.test(email);
  };
  export   const formatWeekdayText = (weekdayText) => {
    return weekdayText.map((text) => {
      const [dayPart, hoursPart] = text?.split(": ");
      // console.log(weekdayText);
      const jourKey = dayPart?.trim()?.toLowerCase();
      const jour = joursEnFrancais[jourKey] || dayPart;

      let fermee = false;
      let horaire_ouverture = null;
      let horaire_fermeture = null;

      if (!hoursPart || hoursPart.toLowerCase().includes("fermé")) {
        fermee = true;
      } else if (hoursPart.toLowerCase().includes("24h/24")) {
        horaire_ouverture = "ouvert toute la journée";
        horaire_fermeture = "ouvert toute la journée";
      } else {
        const [open, close] = hoursPart?.split("–")?.map((t) => t.trim());
        horaire_ouverture = open?.replace(/[^0-9:]/g, "");
        horaire_fermeture = close?.replace(/[^0-9:]/g, "");
      }

      return {
        jour,
        fermee,
        horaire_ouverture,
        horaire_fermeture,
      };
    });
  };
export  const formatUpdateDate = (dateString) => {
    if (!dateString) return "Non mis à jour ";
    const date = new Date(dateString);
    return format(date, "dd/MM/yy", { locale: fr });
  };
  export const validateFrenchIBAN = (value) => {
    if (!value) {
        // console.log('Validation failed: No value provided');
        return false;
    }
    return true
    // Clean the input (remove spaces and make uppercase)
    const iban = value.replace(/\s+/g, '').toUpperCase();
    console.log('Cleaned IBAN:', iban);
    // Special case: Accept all test IBANs (FRkk followed by 21 alphanumeric chars)
    if (iban.startsWith('FRkk') || iban.startsWith('FRKK')) {
      console.log('Test IBAN detected - automatically valid');
      // return /^FR(kk|KK)[a-zA-Z0-9]{21}$/.test(iban); 
      return true; 
  }
    // Check basic IBAN structure (FR followed by 23 alphanumeric characters)
    if (!/^FR[a-zA-Z0-9]{23}$/.test(iban)) {
        console.log('Validation failed: Invalid format');
        return false;
    }
    
    
    
    // For real IBANs, perform full validation
    const rearranged = iban.substring(4) + iban.substring(0, 4);
    console.log('Rearranged IBAN:', rearranged);
    
    const numeric = rearranged.split('').map(c => {
        const code = c.charCodeAt(0);
        return code >= 65 && code <= 90 
            ? (code - 55).toString() 
            : c;
    }).join('');
    console.log('Numeric conversion:', numeric);
    
    try {
        const isValid = bigInt(numeric).mod(97) === 1;
        console.log('Final validation result:', isValid);
        return isValid;
    } catch (e) {
        console.log('Validation error:', e);
        return false;
    }
};


// Format IBAN for display (add spaces every 4 characters)
export const formatIBAN = (iban) => {
  if (!iban) return "";
  return iban
    .replace(/\s+/g, "")
    .replace(/(.{4})/g, "$1 ")
    .trim();
};
export const slugify = (text) => {
  console.log({text})
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s\W-]+/g, "-") // Replace spaces & non-word characters with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
};
export const formatFrenchDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ""; // Handle invalid date

  const formattedDate = new Intl.DateTimeFormat("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric", // Ajout de l'année
  }).format(date);

  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

export const getMondayOfCurrentWeek = (date) => {
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust when Sunday
  return new Date(date.setDate(diff));
};
export const formatDuration = (minutes) => {
  if (minutes < 60) {
    return `${minutes} min${minutes > 1 ? "" : ""}`;
  }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}h${remainingMinutes > 0 ? `${remainingMinutes} min` : ""}`;
};
export const renderLieuBloc = (intervention) => {
  switch (intervention?.lieu_intervention) {
    case "onsite":
      return (
        <div>
          <p className="body bold500 grey500">À domicile</p>
          <p className="body grey66">{intervention?.rue}</p>
          <p className="body grey66">{intervention?.ville}</p>
        </div>
      );
    case "chezpro":
      return (
        <div>
          <p className="body bold500 grey500">Chez le professionnel</p>
          <p className="body grey66"> {intervention?.rue}</p>
        </div>
      );
    case "enligne":
      return (
        <div>
          <p className="body bold500 grey500">En Ligne</p>
          <p className="body grey500">{intervention?.meeting_link}</p>
        </div>
      );
    default:
      return <>Unkown</>;
  }
};
// utils/auth.js

// export const checkTokenValidity = (token) => {
//   if (!token) return false;

//   try {
//     const decoded = jwtDecode(token);
//     return decoded.exp * 1000 > Date.now();
//   } catch (error) {
//     console.error("Invalid token:", error);
//     return false;
//   }
// };

export const checkTokenValidity = (rawToken) => {
  if (!rawToken) return false;

  // Nettoyage du préfixe "Bearer "
  const token = rawToken.startsWith("Bearer ") ? rawToken.slice(7) : rawToken;

  // Vérifier format JWT
  const parts = token.split(".");
  if (parts.length !== 3) {
    console.log("Token mal formé (pas 3 segments):", token);
    return false;
  }

  try {
    const decoded = jwtDecode(token);
    if (!decoded || typeof decoded.exp !== "number") {
      console.log("Token décodé sans exp:", decoded);
      return false;
    }
    // Vérification de l'expiration
    const isValid = decoded.exp * 1000 > Date.now();
    if (!isValid) console.log("Token expiré:", decoded);
    return isValid;
  } catch (err) {
    console.error("Erreur de décodage du token:", err);
    return false;
  }
};


export const clearAuthData = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("adresse_facturation");
};

export const lieuIntervention = () => {
  const locationIcons = {
    enligne: "/images/status.svg",
    onsite: "/images/domi.svg",
    chezpro: "/images/prof.svg",
  };
  return locationIcons;
};

export const StatusRdv = () => {
  const statusIcons = {
    enattente: "/images/attente.svg",
    scheduled:"/images/attente.svg",
    confirme: "/images/comfirm.svg",
    completed: "/images/comfirm.svg",
    passe: "/images/passe.svg",
    annule: "/images/annule.svg",
    cancelled: "/images/annule.svg",
  };
  return statusIcons;
};

export const formatTime = (isoDateStr) => {
  if (!isoDateStr) return "";
  const date = new Date(isoDateStr);

  // Obtenir heures et minutes avec 2 chiffres
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`; // format "HH:mm"
};

export const formatDateToISO = (isoDateStr) => {
  if (!isoDateStr) return "";

  const date = new Date(isoDateStr);
  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // ex: "2025-10-05"
};
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function formatDate(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  const optionsDate = {
    weekday: "long",
    day: "numeric",
    month: "long",
  };

  const optionsTime = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Europe/Paris",
  };

  const formattedDate = new Intl.DateTimeFormat("fr-FR", optionsDate).format(
    date
  );
  const formattedTime = new Intl.DateTimeFormat("fr-FR", optionsTime).format(
    date
  );

  return `${capitalizeFirstLetter(formattedDate)} - ${formattedTime}`;
}

export const isLessThan48h = (startTime) => {
  if (!startTime) return false;
  const startDate = new Date(startTime);
  const now = new Date();
  const diffInHours = (startDate - now) / (1000 * 60 * 60);
  return diffInHours < 48;
};

export function addMinutes(dateStr, minutes) {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}
export const parseDateUTC = (dateStr) => {
  if (!dateStr) return null;
  // Crée un Date en UTC depuis la chaîne ISO
  const d = new Date(dateStr);
  return d;
};

 export const toFrenchTimeUTC = (date) => {
    if (!date) return "";
    return date.toLocaleTimeString("fr-FR", {
      timeZone: "Europe/Paris",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

 export function transformer(dateString) {
  // Convertit "30/05/2025" en "2025-05-30" pour le constructeur Date
  const [day, month, year] = dateString.split('/');
  const date = new Date(`${year}-${month}-${day}`);

  // Options pour afficher le jour de la semaine, le jour du mois, et le mois en toutes lettres
  const options = { weekday: 'long', day: 'numeric', month: 'long' };

  // Formatte la date en français
  return new Intl.DateTimeFormat('fr-FR', options).format(date);
}

// Format the date in French (day month year)
export function formattedDate(isoString) {
  if (!isoString) return ''; // Sécurité si la valeur est null/undefined

  const date = new Date(isoString);

  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function formatDecimalHour(decimalStr) {
  const decimal = parseFloat(decimalStr);
  const totalMinutes = Math.round(decimal * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h${minutes.toString().padStart(2, '0')}`;
}
export function formatMinutesToHourMinute(minutes) {
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hrs}h${mins.toString().padStart(2, '0')}`;
}
export const PlanFeature = ({ text }) => {
  return (
    <div className="d-flex">
      <img src="/images/check-01.svg" alt="check" />
      <span className="text-body-card">{text}</span>
    </div>
  );
};
  export const parseToISOString = (dateStr, timeStr) => {
    const [day, month, yearShort] = dateStr.split("/");
    const year = `20${yearShort}`; // Convertit "25" en "2025"
    const isoString = new Date(`${year}-${month}-${day}T${timeStr}:00Z`).toISOString();
    return isoString;
  };
  // Fonction utilitaire pour parser une date au format 'dd/MM/yyyy'

export const parseDateFromDDMMYYYY = (dateStr) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return new Date("Invalid");

  const [year, month, day] = dateStr.split("-").map(Number);
  const parsedDate = new Date(year, month - 1, day);

  if (
    parsedDate.getFullYear() !== year ||
    parsedDate.getMonth() !== month - 1 ||
    parsedDate.getDate() !== day
  ) {
    return new Date("Invalid");
  }

  return parsedDate;
};
export const  InverseparseDateFromDDMMYY = (dateStr) => {
  const [day, month, year] = dateStr.split("/");
  const fullYear = parseInt(year, 10) < 100 ? 2000 + parseInt(year, 10) : parseInt(year, 10);
  return new Date(fullYear, parseInt(month, 10) - 1, parseInt(day, 10));
}

export function parseDateTime(dateStr, timeStr) {
  let [day, month, year] = dateStr.split("/");

  // Convert 2-digit year to 4-digit
  if (year.length === 2) {
    year = +year < 50 ? `20${year}` : `19${year}`; // You can adjust cutoff here
  }

  // Pad month and day to 2 digits if needed
  month = month.padStart(2, "0");
  day = day.padStart(2, "0");

  // Construct ISO string
  const isoString = `${year}-${month}-${day}T${timeStr}:00`;
  return new Date(isoString);
}
export function datewithTiret(date){
  const formattedDateFormat = date.replace(/\//g, '-'); // '30-06-25'
const [day, month, year] = formattedDateFormat.split('-');
const fullYear = year.length === 2 ? `20${year}` : year;
const formattedDate = `${fullYear}-${month}-${day}`;
return formattedDate;
} 